import { configureStore } from '@reduxjs/toolkit';

import windowObserver from '@utils/WindowObserver/window-observer.slice';
import cookies from '@utils/Cookies/cookies.slice';
import keySelector from '@App/components/KeySelector/key-selector.slice';
import consumers from '@App/pages/Consumers/consumers.store';
import sourceLegend from '@App/components/SourcesLegend/source-legend.store';
import flowingWaterGraph from '@App/components/GraphPanel/PotentialGraph/potential-graph.store';

const createStoreArgs = [];

if (import.meta.env.DEV) {
  const { createLogger } = await import('redux-logger');
  const logger = createLogger({
    collapsed: (_getState, _action, logEntry) => !logEntry.error,
  });

  createStoreArgs.push(logger);
}

const store = configureStore({
  reducer: {
    windowObserver,
    cookies,
    keySelector,
    consumers,
    sourceLegend,
    flowingWaterGraph,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(createStoreArgs),
});

export default store;
